// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"checkInEditor_pageContainer__1-q-L","noticeWrapper":"checkInEditor_noticeWrapper__3WX0a","mainContent":"checkInEditor_mainContent__2ufKS"};